<template>
    <div class="resumeOther">
        <el-row>
            <el-col :span="4" class="resumeItem">
                <h1>语言</h1>
            </el-col>
            <el-col :span="20">
                <div class="resumeContent">
                    <p class="rateDiv" v-for="(item,index) in resumeInfo.languageList">
                        <b>{{item.name}}</b>
                        <el-rate
                            class="resumeRate"
                            disabled-void-icon-class="unActive"
                            disabled
                            :max="4"
                            text-color="#ff9900"
                            score-template="{value}"
                            :value="matchRate(item.level)">
                        </el-rate>
                        <span>{{ dictFormatter(levelOptions, item.level) }}</span>
                    </p>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import {getTreeListByDictType} from '@/api/dict';

    export default {
        name: 'language',
        props: ['resumeInfo'],
        data () {
            return {
                levelOptions: [],   // 掌握程度
            }
        },
        created() {
            this.loadDictData();
        },
        computed: {
            // 简历工作经历列表数量
            languageSize(){
                return this.size();
            }
        },
        methods: {
            loadDictData(){
                getTreeListByDictType("mastery").then(response => {
                    this.levelOptions = response.data
                });
            },
            // 计算简历工作经历数量
            size(){
                let languageSize = 0;
                for(let i in this.resumeInfo.languageList) {
                    languageSize++;
                }
                return languageSize;
            },
            matchRate(item){
                if(item === 'COMMONLY'){
                    return 1
                }else if(item === 'GOOD'){
                    return 2
                }else if(item === 'SKILLED'){
                    return 3
                }else if(item === 'MASTER'){
                    return 4
                }
            },
        },
    }
</script>